import { create } from 'zustand';
import { MessageModeEnum, MessageScheduleState, ScheduleModeEnum } from '../message-schedule.types';

export const useMessageScheduleStore = create<MessageScheduleState>((set) => ({
  messageMode: MessageModeEnum.SEND,
  scheduleMode: ScheduleModeEnum.INITIAL_SCHEDULE,
  updateMessageParameters: null,
  scheduledMessageId: null,
  isScheduleMessagesModalOpen: false,
  isScheduleTimeModalOpen: false,
  isPopoverOpen: false,
  deletePopoverOpen: false,

  setMessageMode: (mode) => set({ messageMode: mode }),
  setScheduleMode: (mode) => set({ scheduleMode: mode }),
  setUpdateMessageParameters: (params) => set({ updateMessageParameters: params }),
  setScheduledMessageId: (id) => set({ scheduledMessageId: id }),
  openScheduleMessagesModal: () => set({ isScheduleMessagesModalOpen: true }),
  closeScheduleMessagesModal: () => set({ isScheduleMessagesModalOpen: false }),
  openScheduleTimeModal: () => set({ isScheduleTimeModalOpen: true }),
  closeScheduleTimeModal: () => set({ isScheduleTimeModalOpen: false }),
  setPopoverOpen: (open) => set({ isPopoverOpen: open }),
  setDeletePopoverOpen: (open) => set({ deletePopoverOpen: open }),

  resetToSendMode: () =>
    set({
      messageMode: MessageModeEnum.SEND,
      scheduledMessageId: null,
      updateMessageParameters: null,
      isPopoverOpen: false,
    }),

  resetAll: () =>
    set({
      messageMode: MessageModeEnum.SEND,
      scheduleMode: ScheduleModeEnum.INITIAL_SCHEDULE,
      updateMessageParameters: null,
      scheduledMessageId: null,
      isScheduleMessagesModalOpen: false,
      isScheduleTimeModalOpen: false,
      isPopoverOpen: false,
      deletePopoverOpen: false,
    }),
}));
